import Button from "../../atoms/button/Button";
import styles from "./PopUpButtons.module.css"
import ButtonColor from './../../../../enums/ButtonColor';

function PopUpButtons({ className, hasCancelBtn, hasBtn1, hasBtn2, textBtn1, textBtn2, classBtn1, classBtn2, onClickCancel, onClickBtn1, onClickBtn2, variantBtn1, variantBtn2, variantCancel, btn1HasArrow, btn2HasArrow, cancelHasArrow, btn1Disabled, btn2Disabled, ...props }) {
    return (
        <div className={[styles.flexContainer, className].filter(e => !!e).join(' ')} {...props}>
            <span className={styles.flexSpan}>
                {hasBtn1 && <Button title={textBtn1} className={classBtn1} onClick={onClickBtn1} variant={variantBtn1} hasArrow={btn1HasArrow} isDisabled={btn1Disabled} />}
                {hasBtn2 && <Button title={textBtn2} className={classBtn2} onClick={onClickBtn2} variant={variantBtn2} hasArrow={btn2HasArrow} isDisabled={btn2Disabled} />}
            </span>
            {hasCancelBtn && <Button hasNoBackground={true} title={"CANCEL"} variant={variantCancel} onClick={onClickCancel} hasArrow={cancelHasArrow} />}
        </div>
    )
}

PopUpButtons.defaultProps = {
    variantCancel: ButtonColor.grey
}

export default PopUpButtons;